import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { getAggMeasurements } from "../thunk/substanceThunk";
import { getDetectionAggMeasurements } from "../thunk/detection";
import { getSubstabceConfiguration } from '../../store/thunk/categorySubstanceThunk';

interface InitialState {
    subStanceList: any;
    aggSubstanceList: any;
    detectionAggSubstanceList: any;
    relatedSubstanceList: any;
    detailMeasurementsList: any;
    substancedetails: any;
    queryDetailsList: any;
    loading: boolean;
    substanceThresholdsList: any;
    substanceThresholdsDefaultList: any;
    substanceConfigurationList: any;
    substanceHistory: any;
    substanceScheduleReportList: any;
    measurementLoading: boolean;
    detectionMeasurementLoading: boolean;
    subStanceLoading:boolean;
}
const initialState: InitialState = {
    subStanceList: [],
    aggSubstanceList: [],
    detectionAggSubstanceList: [],
    relatedSubstanceList: [],
    detailMeasurementsList: [],
    substancedetails: [],
    queryDetailsList: [],
    loading: false,
    substanceThresholdsList: [],
    substanceThresholdsDefaultList: [],
    substanceConfigurationList: [],
    substanceHistory: [],
    substanceScheduleReportList: [],
    measurementLoading: false,
    detectionMeasurementLoading: false,
    subStanceLoading:false
};

const subStanceSlice = createSlice({
    name: "tenant",
    initialState,
    reducers: {
        subStanceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            subStanceList: action.payload,
        }),
        setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            loading: action.payload,
        }),
        setLoaderMeasurement: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            measurementLoading: action.payload,
        }),
        setMeasurementDataNotFound: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            measurementNotFound: action.payload,
        }),
        aggSubstanceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            aggSubstanceList: action.payload,
        }),
        relatedSubstanceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            relatedSubstanceList: action.payload,
        }),
        getDetailMeasurementsList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detailMeasurementsList: action.payload,
        }),
        getSubstanceDetailList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substancedetails: action.payload,
        }),
        getQueryDetailsList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            queryDetailsList: action.payload,
        }),
        substanceThresholdsList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substanceThresholdsList: action.payload,
        }),
        substanceThresholdsDefaultList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substanceThresholdsDefaultList: action.payload,
        }),
        substanceConfigurationList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substanceConfigurationList: action.payload,
        }),
        getSubstanceHistoryList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substanceHistory: action.payload,
        }),
        setSubstanceScheduleReportList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            substanceScheduleReportList: action.payload,
        }),
        detectionAggSubstanceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            detectionAggSubstanceList: action.payload,
        }),

    },
    extraReducers: (builder) => {
        builder
          .addCase(getSubstabceConfiguration.pending, (state) => {
            state.subStanceLoading = true;
          })
          .addCase(getSubstabceConfiguration.fulfilled, (state) => {
            state.subStanceLoading = false;
          })
          .addCase(getSubstabceConfiguration.rejected, (state) => {
            state.subStanceLoading = false;
          })
          .addCase(getAggMeasurements.pending, (state) => {
            state.measurementLoading = true;
          })
          .addCase(getAggMeasurements.fulfilled, (state) => {
            state.measurementLoading = false;
          })
          .addCase(getAggMeasurements.rejected, (state) => {
            state.measurementLoading = false;
          })          
          .addCase(getDetectionAggMeasurements.pending, (state) => {
            state.detectionMeasurementLoading = true;
          })
          .addCase(getDetectionAggMeasurements.fulfilled, (state) => {
            state.detectionMeasurementLoading = false;
          })
          .addCase(getDetectionAggMeasurements.rejected, (state) => {
            state.detectionMeasurementLoading = false;
          })          
      }
})
export const { getSubstanceHistoryList, detectionAggSubstanceList, subStanceList, setLoader, setLoaderMeasurement, aggSubstanceList, relatedSubstanceList, getDetailMeasurementsList, getSubstanceDetailList, getQueryDetailsList, substanceThresholdsList, substanceConfigurationList, substanceThresholdsDefaultList, setMeasurementDataNotFound, setSubstanceScheduleReportList } = subStanceSlice.actions;
export default subStanceSlice.reducer;